import api from "../services";

const timeSheetAPI = api.injectEndpoints({
    endpoints: (builder) =>({
        getTimeSheetsByID: builder.query({
            query: (payload) => ({
                url: `/api/workLogManagement/fill/eligibility/status`,
                method: "POST",
                body: payload
            })
        }),
    })
})

export default timeSheetAPI;
export const {useLazyGetTimeSheetsByIDQuery} = timeSheetAPI;